export default __webpack_public_path__ + "static/media/back.1e7d0b00.png";